import "./Brands.module.css";
import Header from "@/reusable_sections/Header";
import Placeholderbanner from "./sections/Placeholderbanner";
import Partners from "./sections/Partners";
import BrandsFeatured from "./sections/BrandsFeatured";
import BrandMerlinShowcase from "./sections/BrandMerlinShowcase";
import SuperliftOperators from "./sections/SuperliftOperators";
import BrandPromotion from "./sections/BrandPromotion";
import GliderolBrandShowcase from "./sections/GliderolBrandShowcase";
import BrandAtaShowcase from "./sections/BrandAtaShowcase";
import BrandForzaShowcase from "./sections/BrandForzaShowcase";
import Expertise from "./sections/Expertise";
import Services from "./sections/Services";
import Brands from "./sections/Brands";
import GarageFaq from "./sections/GarageFaq";
import Brandscta from "./sections/Brandscta";
import CompanyFooter from "./sections/CompanyFooter";
export default function BrandsPage() {
  return <div>
      <Header />
      <Placeholderbanner />
      <Partners />
      <BrandsFeatured />
      <BrandMerlinShowcase />
      <SuperliftOperators />
      <BrandPromotion />
      <GliderolBrandShowcase />
      <BrandAtaShowcase />
      <BrandForzaShowcase />
      <Expertise />
      <Services />
      <Brands />
      <GarageFaq />
      <Brandscta />
      <CompanyFooter />
    </div>;
}